module.exports = __webpack_public_path__ + "img/th.5eb0bad6.svg";